<template>
  <el-container v-loading="loading" element-loading-text="Ładowanie projektu...">
    <button v-if="!isMobile" @click="toggle" class="toggle" :class="{ open: leftSidebar }">
      <span :class="{ 'el-icon-arrow-right': !leftSidebar, 'el-icon-arrow-left': leftSidebar }"></span>
    </button>
    <el-button class="mobileToggle" v-if="isMobile" @click="toggle" icon="el-icon-menu" circle></el-button>
    <LeftSidebar v-if="leftSidebar"></LeftSidebar>
    <el-container>
      <el-main class="main" ref="main">
        <TopBar v-show="!isPreview" />
        <el-alert
          v-if="overlappingText"
          title="Jeden z tekstów nachodzi na inny! Popraw, aby wydruk był prawidłowy."
          type="error"
          effect="dark"
        >
        </el-alert>
        <el-alert class="preview" v-if="isPreview" title="Podgląd nazwiska" type="warning" effect="dark" close-text="Wyjdź" @close="handlePreviewClose">
          Włączono podgląd nazwiska. Możesz przesunąc pole personalizowane lub złamać tekst do nowej lini. Dokonane zmiany będą dotyczyć tylko tego nazwiska.
        </el-alert>
        <el-alert v-if="false" title="Projekt został przesłany. Jego edycja nie jest już możliwa" type="error" effect="dark"> </el-alert>
        <el-card ref="canvasContainer" class="box-card canvas" v-click-outside="hideContext">
          <canvas ref="canvas" :style="canvasStyle"></canvas>
          <!-- <TabsNavigation /> -->
        </el-card>
        <ActionMenu v-if="allowEdit"></ActionMenu>
        <Legends />
      </el-main>
    </el-container>
    <RightSidebar></RightSidebar>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LeftSidebar from '../components/LeftSidebar.vue';
import RightSidebar from '../components/RightSidebar.vue';
import ActionMenu from '../components/ActionMenu.vue';
import TopBar from '../components/Editor/TopBar.vue';
import Legends from '../components/Editor/Legends.vue';
import Editor from '../classes/Editor';

import ClickOutside from 'vue-click-outside';

export default {
  name: 'Editor',
  data() {
    return {
      loading: true,
      isMobile: false,
      leftSidebar: true,
      overlappingText: false,
      editor: null
    };
  },
  computed: {
    ...mapGetters('creator', ['scene', 'project', 'activeScene', 'activeVersion', 'version', 'previewGuestIndex', 'previewGuest', 'isPreview', 'isBlocked']),
    ...mapGetters('user', ['loggedIn']),
    allowEdit() {
      if (this.loggedIn) {
        return true;
      }

      return !this.isBlocked;
    },
    canvasStyle() {
      return this.version && this.version.border
        ? {
            border: `1px solid ${this.version.borderColor}`,
            borderWidth: `${this.version.border.top}px ${this.version.border.right}px ${this.version.border.bottom}px ${this.version.border.left}px`,
          }
        : {};
    },
  },
  async mounted() {
    try {
      // Get a template code
      const routeId = this.$route.params.id || null;

      // Check if hash
      const isUserProject = routeId.length == 16;

      const project = isUserProject ? await this.getProject(routeId) : await this.getDraft(routeId)

      if (!project) {
        throw new Error('Project not found')
      }

      await Editor.init(this.$refs.canvas, project)

        if (this.version) {
          console.log('load version content', this.version.content)
          await Editor.loadContent(this.version.content)
        } else {
          console.log('no versions')
        }

    } catch (error) {
      this.$alert(
        'Nie znaleziono projektu. Upewnij się, że adres url jest poprawny. Jeżeli problem wciąż występuje, prosimy skontaktuj się z nami.',
        'Ups...',
        {
          confirmButtonText: 'OK',
        }
      );
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('creator', {
      getDraft: 'getDraft',
      getProject: 'getProject',
      setPreviewGuestIndex: 'setPreviewGuestIndex',
      setPresonalizedValue: 'setPresonalizedValue'
    }),
    ...mapActions('file', {
      getImages: 'getImages',
    }),
    toggle() {
      this.leftSidebar = !this.leftSidebar;
    },
    hideContext(event) {
      if (event.target.closest('.right') || event.target.closest('.action-menu')) {
        return true;
      }

      if (Editor.canvas) {
        Editor.canvas.discardActiveObject().renderAll();
      }
    },
    handlePreviewClose() {
      this.setPreviewGuestIndex(null)
      Editor.setPreview(null)
    }
  },
  directives: {
    ClickOutside,
  },
  components: {
    TopBar,
    Legends,
    ActionMenu,
    LeftSidebar,
    RightSidebar,
    // TabsNavigation,
  },
};
</script>

<style lang="less" scoped>
.el-alert.el-alert--warning .el-alert__closebtn {
  font-weight: bold;
}
.leftside {
  @media (min-width: 1024px) {
    position: static !important;
  }
  .el-drawer {
    padding: 0;
    border-right: 1px solid #e4e4e4;
    box-sizing: border-box;
  }
  .el-drawer__header {
    margin-bottom: 0;
  }
  .el-drawer__body {
    height: calc(100vh - 45px);
  }
}
.mobileToggle {
  position: fixed;
  bottom: 95px;
  left: 20px;
  z-index: 1;
}
.toggle {
  display: none;
  border: 0;
  color: #333;
  font-size: 25px;
  height: 50px;
  transform: translate(-50%);
  cursor: pointer;
  background: rgba(#fff, 0.4);
  transition: background 0.3s, left 0.3s, padding 0.3s;
  border: 1px solid #e4e4e4;
  padding: 0;
  position: absolute;
  top: 50%;
  left: 5px;
  span {
    position: relative;
    left: 4px;
    transition: 0.3s;
  }
  &.open {
    left: 355px;
    &:hover {
      left: 367px;
    }
  }
  &:hover {
    padding: 0 5px;
    background: #fff;
    left: 17px;
    span {
      left: 0;
    }
  }
}

.preview {
  max-width: calc(100% - 20px);
}

.box-card.canvas {
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  background-image: radial-gradient(#e3e5eb 6%, #f4f6fc 5%);
  background-position: 0 0;
  background-size: 40px 40px;

  @media (min-width: 1024px) {
    padding: 50px;
  }

  /deep/ .el-card__body {
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
}
.canvas {
  height: 100%;
  position: relative;
  background: transparent;
  box-shadow: none !important;
  border-radius: 0;
  border: 0;
  overflow: auto;
  height: calc(100vh - 100px);
  transform-origin: 0 0;
  margin-top: 20px;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    height: calc(100vh - 98px);
  }

  .context {
    position: absolute;
    top: 80px;
    display: none;
    width: 40px;
    overflow: hidden;
    button {
      border: 0;
      background: rgb(80, 79, 79);
      color: #ccc;
      font-size: 12px;
      height: 30px;
      width: 30px;
      cursor: pointer;
      &:hover {
        color: #fff;
      }
    }
  }
}

.el-main {
  display: flex;
  align-items: center;
  padding: 0;
  position: relative;
  overflow: hidden;
  justify-content: flex-start;
  flex-direction: column;
  @media (min-width: 1024px) {
    justify-content: center;
  }
  .el-alert {
    margin-bottom: 30px;
  }
  > .el-card {
    margin: 0 auto;
  }
}
.el-notification__content {
  text-align: left;
}
small {
  line-height: 18px;
}
</style>
